/**
 * @fileoverview gRPC-Web generated client stub for test
 * @enhanceable
 * @public
 */

// Code generated by protoc-gen-grpc-web. DO NOT EDIT.
// versions:
// 	protoc-gen-grpc-web v1.4.2
// 	protoc              v3.21.12
// source: protobuf/helloworld/helloworld.proto


/* eslint-disable */
// @ts-nocheck


import * as grpcWeb from 'grpc-web';

import * as protobuf_helloworld_helloworld_pb from '../../protobuf/helloworld/helloworld_pb';


export class GreeterClient {
  client_: grpcWeb.AbstractClientBase;
  hostname_: string;
  credentials_: null | { [index: string]: string; };
  options_: null | { [index: string]: any; };

  constructor (hostname: string,
               credentials?: null | { [index: string]: string; },
               options?: null | { [index: string]: any; }) {
    if (!options) options = {};
    if (!credentials) credentials = {};
    options['format'] = 'binary';

    this.client_ = new grpcWeb.GrpcWebClientBase(options);
    this.hostname_ = hostname.replace(/\/+$/, '');
    this.credentials_ = credentials;
    this.options_ = options;
  }

  methodDescriptorSayHello = new grpcWeb.MethodDescriptor(
    '/test.Greeter/SayHello',
    grpcWeb.MethodType.UNARY,
    protobuf_helloworld_helloworld_pb.HelloRequest,
    protobuf_helloworld_helloworld_pb.HelloReply,
    (request: protobuf_helloworld_helloworld_pb.HelloRequest) => {
      return request.serializeBinary();
    },
    protobuf_helloworld_helloworld_pb.HelloReply.deserializeBinary
  );

  sayHello(
    request: protobuf_helloworld_helloworld_pb.HelloRequest,
    metadata: grpcWeb.Metadata | null): Promise<protobuf_helloworld_helloworld_pb.HelloReply>;

  sayHello(
    request: protobuf_helloworld_helloworld_pb.HelloRequest,
    metadata: grpcWeb.Metadata | null,
    callback: (err: grpcWeb.RpcError,
               response: protobuf_helloworld_helloworld_pb.HelloReply) => void): grpcWeb.ClientReadableStream<protobuf_helloworld_helloworld_pb.HelloReply>;

  sayHello(
    request: protobuf_helloworld_helloworld_pb.HelloRequest,
    metadata: grpcWeb.Metadata | null,
    callback?: (err: grpcWeb.RpcError,
               response: protobuf_helloworld_helloworld_pb.HelloReply) => void) {
    if (callback !== undefined) {
      return this.client_.rpcCall(
        this.hostname_ +
          '/test.Greeter/SayHello',
        request,
        metadata || {},
        this.methodDescriptorSayHello,
        callback);
    }
    return this.client_.unaryCall(
    this.hostname_ +
      '/test.Greeter/SayHello',
    request,
    metadata || {},
    this.methodDescriptorSayHello);
  }

  methodDescriptorSayHelloStream = new grpcWeb.MethodDescriptor(
    '/test.Greeter/SayHelloStream',
    grpcWeb.MethodType.SERVER_STREAMING,
    protobuf_helloworld_helloworld_pb.HelloRequest,
    protobuf_helloworld_helloworld_pb.HelloReply,
    (request: protobuf_helloworld_helloworld_pb.HelloRequest) => {
      return request.serializeBinary();
    },
    protobuf_helloworld_helloworld_pb.HelloReply.deserializeBinary
  );

  sayHelloStream(
    request: protobuf_helloworld_helloworld_pb.HelloRequest,
    metadata?: grpcWeb.Metadata): grpcWeb.ClientReadableStream<protobuf_helloworld_helloworld_pb.HelloReply> {
    return this.client_.serverStreaming(
      this.hostname_ +
        '/test.Greeter/SayHelloStream',
      request,
      metadata || {},
      this.methodDescriptorSayHelloStream);
  }

}

